import { createSlice } from '@reduxjs/toolkit';

import { RiskSecurityState } from '../types';
import store from './store';
import endPoints from '../api/endpoint';
import { getApiCall, postApiCall, putApiCall } from '../api/methods';
import { notify } from '../Utils/toastify';

import dayjs from 'dayjs';

import utc from 'dayjs/plugin/utc';
import { downloadPdf } from '../Utils/helperFns';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../Utils/firebaseConfig';
import { ANALYTICS_EVENTS } from '../helpers/analyticsEvents';
dayjs.extend(utc);

const initialState: RiskSecurityState = {
  studioDetails: {},
  loading: true,
  studioProductionList: {},
  studioLocations: {},
  studioAnalyticsData: {},
  studioAnalyticsDayData: {},
  studioAnlyticsLocationData: {},
  organizations: [],
  threatSubCategory: [],
  reporters: [],
  threatType: [],
  episodeListing: [],
  setListing: [],
  locationsList: [],
  draftList: [],
  vulnerability: {},
  productions: [],
  loader: false,
  productionBasicDetails: {},
  productionAnalytics: {},
  productionSets: {},
  productionAnalyticsData: {},
  productionAnalyticsDayData: {},
  productionAnalyticsLocationData: {},
  productionDashboardLocationThreats: {},
  productionDashboardLocations: {},
  episodeBasicDetails: {},
  episodeAnalyticsData: {},
  episodeAnalyticsDayData: {},
  episodeAnalyticsLocationData: {},
  episodeDashboardLocationThreats: {},
  episodeSets: {},
  setBasicDetails: {},
  setAnalyticsData: {},
  setAnalyticsDayData: {},
  setAnalyticsLocationData: {},
  setDashboardLocationThreats: {},
  locationDetails: {},
  locationThreatAlerts: [],
  setLocations: {},
  setDashboardLocations: {},
  episodeDashboardLocations: {},
  setDashMapLocations: {},
  activeCriticalLocations: {},
  modalLoading: false,
  locationLoading: false,
  productionDropdownList: {},
  episodeSetDropdownList: {},
  setDropdownList: {},
  locationDropdownList: {},
  locationSubList: [],
  riskLoggedInUserDetail: {},
  singleThreatDetail: {},
};
const riskSecuritySlice = createSlice({
  name: 'riskSecurity',
  initialState,
  reducers: {
    resetRiskCenterState: () => initialState,
    setStudioDetails: (state, action) => {
      const { payload }: any = action;
      state.studioDetails = payload;
    },
    setStudioProductionList: (state, action) => {
      const { payload }: any = action;
      state.studioProductionList = payload;
    },
    setStudioLocations: (state, action) => {
      const { payload }: any = action;
      state.studioLocations = payload;
    },
    setStudioAnalyticsData: (state, action) => {
      const { payload }: any = action;
      state.studioAnalyticsData = payload;
    },
    setStudioAnalyticsDayData: (state, action) => {
      const { payload }: any = action;
      state.studioAnalyticsDayData = payload;
    },
    setStudioAnalyticsLocationData: (state, action) => {
      const { payload }: any = action;
      state.studioAnlyticsLocationData = payload;
    },
    setLoading: (state, action) => {
      const { payload }: any = action;
      state.loading = payload;
    },
    setOrganizations: (state, action) => {
      const { payload }: any = action;
      state.organizations = payload;
    },
    setThreatSubCategory: (state, action) => {
      const { payload }: any = action;
      state.threatSubCategory = payload;
    },
    setReporter: (state, action) => {
      const { payload }: any = action;
      state.reporters = payload;
    },
    setThreatType: (state, action) => {
      const { payload }: any = action;
      state.threatType = payload;
    },
    setEpisodeList: (state, action) => {
      const { payload }: any = action;
      state.episodeListing = payload;
    },
    setSetList: (state, action) => {
      const { payload }: any = action;
      state.setListing = payload;
    },
    setLocationsList: (state, action) => {
      const { payload }: any = action;
      state.locationsList = payload;
    },
    setLocationSubList: (state, action) => {
      const { payload }: any = action;
      state.locationSubList = payload;
    },
    setDraftList: (state, action) => {
      const { payload }: any = action;
      state.draftList = payload;
    },
    setVulnerabilityReport: (state, action) => {
      const { payload }: any = action;
      state.vulnerability = payload;
    },
    setProductionList: (state, action) => {
      const { payload }: any = action;
      state.productions = payload;
    },
    setLoaderStatus: (state, action) => {
      const { payload }: any = action;
      state.loader = payload;
    },
    setProductionBasicDetails: (state, action) => {
      const { payload }: any = action;
      state.productionBasicDetails = payload;
    },
    setProductionAnalytics: (state, action) => {
      const { payload }: any = action;
      state.productionAnalytics = payload;
    },
    setProductionSets: (state, action) => {
      const { payload }: any = action;
      state.productionSets = payload;
    },
    setProductionAnalyticsData: (state, action) => {
      const { payload }: any = action;
      state.productionAnalyticsData = payload;
    },
    setProductionAnalyticsDayData: (state, action) => {
      const { payload }: any = action;
      state.productionAnalyticsDayData = payload;
    },
    setProductionAnalyticsLocationData: (state, action) => {
      const { payload }: any = action;
      state.productionAnalyticsLocationData = payload;
    },
    setProductionDashboardLocationThreats: (state, action) => {
      const { payload }: any = action;
      state.productionDashboardLocationThreats = payload;
    },
    setEpisodeBasicDetails: (state, action) => {
      const { payload }: any = action;
      state.episodeBasicDetails = payload;
    },
    setEpisodeAnalyticsData: (state, action) => {
      const { payload }: any = action;
      state.episodeAnalyticsData = payload;
    },
    setEpisodeAnalyticsDayData: (state, action) => {
      const { payload }: any = action;
      state.episodeAnalyticsDayData = payload;
    },
    setEpisodeAnalyticsLocationData: (state, action) => {
      const { payload }: any = action;
      state.episodeAnalyticsLocationData = payload;
    },
    setEpisodeDashboardLocationThreats: (state, action) => {
      const { payload }: any = action;
      state.episodeDashboardLocationThreats = payload;
    },
    setEpisodeSets: (state, action) => {
      const { payload }: any = action;
      state.episodeSets = payload;
    },
    setSetBasicDetails: (state, action) => {
      const { payload }: any = action;
      state.setBasicDetails = payload;
    },
    setSetAnalyticsData: (state, action) => {
      const { payload }: any = action;
      state.setAnalyticsData = payload;
    },
    setSetAnalyticsDayData: (state, action) => {
      const { payload }: any = action;
      state.setAnalyticsDayData = payload;
    },
    setSetAnalyticsLocationData: (state, action) => {
      const { payload }: any = action;
      state.setAnalyticsLocationData = payload;
    },
    setSetDashboardLocationThreats: (state, action) => {
      const { payload }: any = action;
      state.setDashboardLocationThreats = payload;
    },
    setSetLocations: (state, action) => {
      const { payload }: any = action;
      state.setLocations = payload;
    },
    setLocationDetails: (state, action) => {
      const { payload }: any = action;
      state.locationDetails = payload;
    },
    setLocationThreatDetails: (state, action) => {
      const { payload }: any = action;
      state.locationThreatAlerts = payload;
    },
    setProductionDashboardLocations: (state, action) => {
      const { payload }: any = action;
      state.productionDashboardLocations = payload;
    },
    setSetDashboardLocations: (state, action) => {
      const { payload }: any = action;
      state.setDashboardLocations = payload;
    },
    setEpisodeDashboardLocations: (state, action) => {
      const { payload }: any = action;
      state.episodeDashboardLocations = payload;
    },
    setSetDashboardmapLocations: (state, action) => {
      const { payload }: any = action;
      state.setDashMapLocations = payload;
    },
    setActiveCriticalLocations: (state, action) => {
      const { payload }: any = action;
      state.activeCriticalLocations = payload;
    },
    setModalLoading: (state, action) => {
      const { payload }: any = action;
      state.modalLoading = payload;
    },
    setLocationLoading: (state, action) => {
      const { payload }: any = action;
      state.locationLoading = payload;
    },
    setProductionDropdownList: (state, action) => {
      state.productionDropdownList = action.payload || [];
    },

    appendProductionDropdownList: (state, action) => {
      state.productionDropdownList = [
        ...state.productionDropdownList,
        ...(action.payload || []),
      ];
    },
    resetProductionDropdownList: state => {
      state.productionDropdownList = [];
    },
    setEpisodeSetDropdownList: (state, action) => {
      state.episodeSetDropdownList = action.payload || [];
    },
    appendEpisodeSetDropdownList: (state, action) => {
      state.episodeSetDropdownList = [
        ...state.episodeSetDropdownList,
        ...(action.payload || []),
      ];
    },
    setSetDropdownList: (state, action) => {
      state.setDropdownList = action.payload || [];
    },
    appendSetDropdownList: (state, action) => {
      state.setDropdownList = [
        ...state.setDropdownList,
        ...(action.payload || []),
      ];
    },
    setLocationDropdownList: (state, action) => {
      state.locationDropdownList = action.payload || [];
    },
    appendLocationDropdownList: (state, action) => {
      state.locationDropdownList = [
        ...state.locationDropdownList,
        ...(action.payload || []),
      ];
    },
    setRiskLoggedInUserDetail: (state, action) => {
      const { payload }: any = action;
      state.riskLoggedInUserDetail = payload;
    },
    setSingleThreatDetail: (state, action) => {
      const { payload }: any = action;
      state.singleThreatDetail = payload;
    },
  },
});

export const {
  resetRiskCenterState,
  setStudioDetails,
  setLoading,
  setStudioProductionList,
  setStudioLocations,
  setStudioAnalyticsData,
  setStudioAnalyticsDayData,
  setStudioAnalyticsLocationData,
  setOrganizations,
  setThreatSubCategory,
  setReporter,
  setThreatType,
  setEpisodeList,
  setSetList,
  setLocationsList,
  setDraftList,
  setVulnerabilityReport,
  setProductionList,
  setLoaderStatus,
  setProductionBasicDetails,
  setProductionAnalytics,
  setProductionSets,
  setProductionAnalyticsData,
  setProductionAnalyticsDayData,
  setProductionAnalyticsLocationData,
  setProductionDashboardLocationThreats,
  setProductionDashboardLocations,
  setEpisodeBasicDetails,
  setEpisodeAnalyticsData,
  setEpisodeAnalyticsDayData,
  setEpisodeAnalyticsLocationData,
  setEpisodeDashboardLocationThreats,
  setEpisodeSets,
  setSetBasicDetails,
  setSetAnalyticsData,
  setSetAnalyticsDayData,
  setSetDashboardLocations,
  setSetAnalyticsLocationData,
  setSetDashboardLocationThreats,
  setLocationDetails,
  setLocationThreatDetails,
  setSetLocations,
  setEpisodeDashboardLocations,
  setSetDashboardmapLocations,
  setActiveCriticalLocations,
  setModalLoading,
  setLocationLoading,
  setProductionDropdownList,
  resetProductionDropdownList,
  appendProductionDropdownList,
  setEpisodeSetDropdownList,
  appendEpisodeSetDropdownList,
  setSetDropdownList,
  appendSetDropdownList,
  setLocationDropdownList,
  appendLocationDropdownList,
  setLocationSubList,
  setRiskLoggedInUserDetail,
  setSingleThreatDetail,
} = riskSecuritySlice.actions;

export const getRiskStudioBasicDetails = (id: string) => {
  const { dispatch } = store;
  dispatch(setLoading(true));
  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.studioDashOverview.replace(
    '{studioId}',
    id || '',
  );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLoading(false));
        dispatch(setStudioDetails(data?.data));
      }
    },
    (e: any) => {
      dispatch(setLoading(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getRiskStudioProduction = (
  id: string,
  params?: {
    productionStatus?: string;
    riskLevel?: string;
    productionId?: string;
    page?: number;
    limit?: number;
    searchKey?: string;
  },
  cb?: any,
) => {
  const apiendpoint = endPoints.riskSecurity.studioDashProductions.replace(
    '{studioId}',
    id || '',
  );

  console.log(params, 'ejkbfkje');

  const query = new URLSearchParams();

  if (params?.productionStatus)
    query.append('productionStatus', params.productionStatus);

  if (params?.riskLevel) query.append('riskLevel', params.riskLevel);
  if (params?.productionId) query.append('productionId', params.productionId);

  if (params?.page) query.append('page', String(params.page));
  if (params?.limit) query.append('limit', String(params.limit));
  if (params?.searchKey) query.append('searchKey', String(params.searchKey));

  const url = query.toString()
    ? `${apiendpoint}?${query.toString()}`
    : apiendpoint;

  getApiCall(
    url,
    (s: any) => {
      if (cb) cb(s?.data);
    },
    (e: any) => {
      notify(e?.data?.message || null, 'error');
    },
  );
};

export const getRiskStudioLocations = (
  id: string,
  page?: number,
  limit?: number,
) => {
  const { dispatch } = store;

  dispatch(setLocationLoading(true));

  // Replace {studioId} in the route with the value
  let apiendpoint = endPoints.riskSecurity.studioDashLocations.replace(
    '{studioId}',
    id || '',
  );

  // Add pagination params
  apiendpoint = `${apiendpoint}?page=${page}&limit=${limit}`;

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLocationLoading(false));
        dispatch(setStudioLocations(data?.data));
      }
    },
    (e: any) => {
      dispatch(setLocationLoading(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getRiskStudioAnalticsByTypeAndLevel = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.studioDashAnalytics.replace(
    '{studioId}',
    id || '',
  );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setStudioAnalyticsData(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};
export const getRiskStudioAnalticsByDay = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.studioDashDaywiseThreats.replace(
    '{studioId}',
    id || '',
  );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setStudioAnalyticsDayData(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getRiskStudioAnalticsByLocations = (id: string) => {
  const { dispatch } = store;

  const apiendpoint = endPoints.riskSecurity.studioDashLocationThreats.replace(
    '{studioId}',
    id || '',
  );

  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      let { data } = s;

      if (data?.data?.locations) {
        // 🔥 Transform severities: remove keys with value 0
        const transformedLocations = data.data.locations.map((loc: any) => ({
          ...loc,
          severities: Object.fromEntries(
            Object.entries(loc.severities).filter(([_, val]) => val > 0),
          ),
        }));

        // Replace original data with filtered data
        data = {
          ...data,
          data: {
            ...data.data,
            locations: transformedLocations,
          },
        };
      }

      dispatch(setStudioAnalyticsLocationData(data));
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getOrganizations = (
  cb?: any,
  errorCb?: any,
  entityId?: string,
  entityType?: string,
) => {
  const { dispatch } = store;
  let apiendpoint = endPoints.riskSecurity.getOrganizations;
  if (entityType && entityId) {
    apiendpoint += `?entityId=${entityId}&entityType=${entityType}`;
  }
  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        console.log('Organizations =>>>>>', data);
        dispatch(setOrganizations(data?.data));

        cb && cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');

        errorCb && errorCb();
      }
    },
  );
};

export const getThreatSubCategory = (id: string, cb?: any) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskSecurity.getThreatSubCategory;

  // Make the API call
  getApiCall(
    `${apiendpoint}?threatTypeId=${id}`,
    (s: any) => {
      const { data } = s;
      const list = data?.data;
      cb?.(Array.isArray(list) ? list : []);
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
      cb?.([]);
    },
  );
};

export const saveDraft = (
  payload: any,
  reset: any,
  mode?: string,
  cb?: (data: any) => void,
  errorCb?: () => void,
) => {
  const endPoint =
    mode === 'VULNERABILITY'
      ? endPoints.riskSecurity.saveDraft
      : endPoints.riskSecurity.saveDraftAlert;
  postApiCall(
    `${endPoint}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode, message, data },
      } = s;

      if (statusCode) {
        if (cb) cb(data);
        reset?.();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        errorCb?.();
      }
    },
  );
};

export const getOrganizationsReporter = (
  id: string,
  entityId?: string,
  entityType?: string,
) => {
  const { dispatch } = store;
  let apiendpoint = `${endPoints.riskSecurity.getOrganizationsReporter}?departmentId=${id}`;

  if (entityId && entityType) {
    apiendpoint += `&entityId=${entityId}&entityType=${entityType}`;
  }

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setReporter(data?.data));

        cb && cb(data?.data);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getThreatType = (cb?: any, errorCb?: any) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskSecurity.getThreatType;

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setThreatType(data?.data));

        cb && cb(data?.data);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');

        errorCb && errorCb();
      }
    },
  );
};

export const getAllProductionList = (query: string, cb?: any) => {
  const { dispatch } = store;
  // dispatch(setCommonDataLoader(true))

  // Build the API endpoint with the query and studioId
  const apiendpoint = `${endPoints.studio.studioProductions}${query}`;
  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setProductionList(data.data.productions));

        if (data.data.productions.length > 0) {
          cb && cb(data.data.productions);
        }
      }
    },
    (e: any) => {
      if (cb) cb([]); // Pass empty array on error

      // dispatch(setCommonDataLoader(false))
    },
  );
};

export const getSetlistbyEpisodeandProductionId = (
  productionId: string,
  episodeId?: string,
  cb?: any,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))

  // Build the API endpoint conditionally based on provided parameters
  let apiendpoint = endPoints.location.setlist;

  const params = [];

  if (productionId) {
    params.push(`productionId=${productionId}`);
  }

  if (episodeId) {
    params.push(`episodeId=${episodeId}`);
  }

  // Append parameters to the endpoint
  if (params.length > 0) {
    apiendpoint += `?${params.join('&')}`;
  }
  dispatch(setSetList([]));
  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setSetList(data?.data));
        if (data?.data?.length > 0) {
          cb?.(data.data);
        }
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
    },
  );
};

export const getEpisodeList = (productionId: string, cb?: any) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.set.episodeListByProduction;
  dispatch(setEpisodeList([]));
  // Make the API call
  getApiCall(
    `${apiendpoint}?productionId=${productionId}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setEpisodeList(data?.data));
        if (data.data.length > 0) {
          cb?.(data.data);
        }
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        //    notify(e?.data.message, 'error')
      } else {
        //   notify(null, 'error')
      }
    },
  );
};

export const getSetLocationsAll = (entityId: any, cb?: any) => {
  const { dispatch } = store;

  // Construct the API endpoint with pagination parameters
  const apiendpoint =
    `${endPoints.riskSecurity.setRisklocations}` +
    `?setId=${entityId}&locationType=general`;
  dispatch(setLocationsList([]));
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;

      if (data.data) {
        const currentData = data.data?.locations;
        dispatch(setLocationsList(currentData));
        if (currentData?.length > 0) {
          cb?.(currentData);
        }
        // cb((prev: any) => [...prev, ...data.data.data])
      }
    },
    (error: any) => {
      console.error('Error fetching order list:', error);
    },
  );
};

export const getSetLocationsAllSubCategory = (entityId: any, cb?: any) => {
  const { dispatch } = store;

  // Construct the API endpoint with pagination parameters
  const apiendpoint =
    `${endPoints.riskSecurity.setRisklocations}` +
    `?setId=${entityId}&locationType=subcat`;

  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;

      if (data.data) {
        const currentData = data.data?.locations;
        dispatch(setLocationSubList(currentData));
        if (currentData?.length > 0) {
          cb?.(currentData);
        }
        // cb((prev: any) => [...prev, ...data.data.data])
      }
    },
    (error: any) => {
      console.error('Error fetching order list:', error);
    },
  );
};

export const getDraftDetail = (id: string, reportType: string, cb?: any) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskSecurity.getDraftDetail;

  dispatch(setLoaderStatus(true));

  // Make the API call
  getApiCall(
    `${apiendpoint}/${id}?reportType=${reportType}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        console.log('Organizations =>>>>>', data);
        cb?.(data?.data);
        dispatch(setLoaderStatus(false));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoaderStatus(false));
      }
    },
  );
};

export const getDraftList = () => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskSecurity.getDraftList;

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setDraftList(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};
export const getVulnerabilityReport = (
  id: string,
  locationId?: any,
  cb?: () => void,
  errorCb?: () => void,
) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  const url = locationId
    ? `${endPoints.riskSecurity.saveDraft}/${id}?locationId=${locationId}`
    : `${endPoints.riskSecurity.saveDraft}/${id}`;
  getApiCall(
    url,

    (s: any) => {
      dispatch(setLoading(false));
      if (s.data) {
        dispatch(setVulnerabilityReport(s?.data?.data));
        if (cb) cb();
      }
    },
    (e: any) => {
      dispatch(setLoading(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        errorCb?.();
      }
    },
  );
};

export const getRiskProductionBasicDetails = (id: string) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  // Replace {studioId} in the route with the value
  const apiendpoint =
    endPoints.riskSecurity.productionDashboardOverview.replace(
      '{productionId}',
      id || '',
    );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLoading(false));
        dispatch(setProductionBasicDetails(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoading(false));
      } else {
        notify(null, 'error');
        dispatch(setLoading(false));
      }
    },
  );
};

// export const getProductionDashboardSets = (
//   id: string,
//   productionStatus?: string,
//   riskLevel?: string,
//   cb?: any,
// ) => {
//   const { dispatch } = store;

//   // Replace {studioId} in the route with the value
//   let apiendpoint =
//     endPoints.riskSecurity.productionDashboardSetThreats.replace(
//       '{productionId}',
//       id || '',
//     );

//   if (productionStatus) {
//     apiendpoint = apiendpoint + `?setStatus=${productionStatus}`;
//   }
//   if (riskLevel) {
//     apiendpoint = apiendpoint + `&riskLevel=${riskLevel}`;
//   }

//   // Make the API call
//   getApiCall(
//     `${apiendpoint}`,
//     (s: any) => {
//       const { data } = s;
//       if (data?.data) {
//         dispatch(setProductionSets(data?.data));
//         if (cb) cb(data?.data);
//       }
//     },
//     (e: any) => {
//       if (e?.data && e?.data.message) {
//         notify(e?.data.message, 'error');
//       } else {
//         notify(null, 'error');
//       }
//     },
//   );
// };
export const getProductionDashboardSets = (
  id: string,
  params?: {
    setStatus?: string;
    riskLevel?: string;
    setId?: string;
    episodeId?: string;
    page?: number;
    limit?: number;
    searchKey?: boolean;
  },
  cb?: any,
) => {
  const apiendpoint =
    endPoints.riskSecurity.productionDashboardSetThreats.replace(
      '{productionId}',
      id || '',
    );

  const query = new URLSearchParams();

  if (params?.setStatus) query.append('setStatus', params.setStatus);

  if (params?.riskLevel) query.append('riskLevel', params.riskLevel);
  if (params?.setId) query.append('setId', params.setId);
  if (params?.episodeId) query.append('episodeId', params.episodeId);

  if (params?.page) query.append('page', String(params.page));
  if (params?.limit) query.append('limit', String(params.limit));
  if (params?.searchKey) query.append('searchKey', String(params.searchKey));

  const url = query.toString()
    ? `${apiendpoint}?${query.toString()}`
    : apiendpoint;

  getApiCall(
    url,
    (s: any) => {
      if (cb) cb(s?.data);
    },
    (e: any) => {
      notify(e?.data?.message || null, 'error');
    },
  );
};

export const getRiskProductionAnalticsByTypeAndLevel = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint =
    endPoints.riskSecurity.productionDashboardAnalytics.replace(
      '{productionId}',
      id || '',
    );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setProductionAnalyticsData(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getProductionAnalyticsByDay = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint =
    endPoints.riskSecurity.productionDashboardDaywiseThreats.replace(
      '{productionId}',
      id || '',
    );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setProductionAnalyticsDayData(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getProductionAnalyticsByLocations = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint =
    endPoints.riskSecurity.productionDashboardLocationThreats.replace(
      '{productionId}',
      id || '',
    );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data) {
        dispatch(setProductionAnalyticsLocationData(data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getProductionDashboardLocations = (
  id: string,
  page?: number,
  limit?: number,
) => {
  const { dispatch } = store;
  dispatch(setLocationLoading(true));
  // Replace {studioId} in the route with the value
  let apiendpoint = endPoints.riskSecurity.productionDashboardLocations.replace(
    '{productionId}',
    id || '',
  );

  // Add pagination params
  apiendpoint = `${apiendpoint}?page=${page}&limit=${limit}`;

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLocationLoading(false));
        dispatch(setProductionDashboardLocations(data?.data));
      }
    },
    (e: any) => {
      dispatch(setLocationLoading(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getRiskEpisodeBasicDetails = (id: string) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.episodeDashboardOverview.replace(
    '{episodeId}',
    id || '',
  );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLoading(false));
        dispatch(setEpisodeBasicDetails(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoading(false));
      } else {
        notify(null, 'error');
        dispatch(setLoading(false));
      }
    },
  );
};

export const getEpisodeDashboardSets = (
  id: string,
  params?: {
    setStatus?: string;
    riskLevel?: string;
    setId?: string;
    page?: number;
    limit?: number;
    searchKey?: boolean;
  },
  cb?: any,
) => {
  const apiendpoint = endPoints.riskSecurity.episodeDashboardSetThreats.replace(
    '{episodeId}',
    id || '',
  );

  const query = new URLSearchParams();

  if (params?.setStatus) query.append('setStatus', params.setStatus);

  if (params?.riskLevel) query.append('riskLevel', params.riskLevel);
  if (params?.setId) query.append('setId', params.setId);

  if (params?.page) query.append('page', String(params.page));
  if (params?.limit) query.append('limit', String(params.limit));
  if (params?.searchKey) query.append('searchKey', String(params.searchKey));

  const url = query.toString()
    ? `${apiendpoint}?${query.toString()}`
    : apiendpoint;

  getApiCall(
    url,
    (s: any) => {
      if (cb) cb(s?.data);
    },
    (e: any) => {
      notify(e?.data?.message || null, 'error');
    },
  );
};

export const getRiskEpisodeAnalticsByTypeAndLevel = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.episodeDashboardAnalytics.replace(
    '{episodeId}',
    id || '',
  );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setEpisodeAnalyticsData(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getEpisodeAnalyticsByDay = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint =
    endPoints.riskSecurity.episodeDashboardDaywiseThreats.replace(
      '{episodeId}',
      id || '',
    );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setEpisodeAnalyticsDayData(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getEpisodeAnalyticsByLocations = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint =
    endPoints.riskSecurity.episodeDashboardLocationThreats.replace(
      '{episodeId}',
      id || '',
    );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data) {
        dispatch(setEpisodeAnalyticsLocationData(data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getEpisodeDashboardLocations = (
  id: string,
  page?: number,
  limit?: number,
) => {
  const { dispatch } = store;
  dispatch(setLocationLoading(true));
  // Replace {studioId} in the route with the value
  let apiendpoint = endPoints.riskSecurity.episodeDashboardLocations.replace(
    '{episodeId}',
    id || '',
  );

  // Add pagination params
  apiendpoint = `${apiendpoint}?page=${page}&limit=${limit}`;

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLocationLoading(false));
        dispatch(setEpisodeDashboardLocations(data?.data));
      }
    },
    (e: any) => {
      dispatch(setLocationLoading(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getRiskSetBasicDetails = (id: string) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.setDashboardOverview.replace(
    '{setId}',
    id || '',
  );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLoading(false));
        dispatch(setSetBasicDetails(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        dispatch(setLoading(false));
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
        dispatch(setLoading(false));
      }
    },
  );
};

export const getRiskSetAnalticsByTypeAndLevel = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.setDashboardAnalytics.replace(
    '{setId}',
    id || '',
  );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setSetAnalyticsData(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getSetAnalyticsByDay = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.setDashboardDaywiseThreats.replace(
    '{setId}',
    id || '',
  );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setSetAnalyticsDayData(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getSetAnalyticsByLocations = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint =
    endPoints.riskSecurity.setDashboardLocationThreats.replace(
      '{setId}',
      id || '',
    );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data) {
        dispatch(setSetAnalyticsLocationData(data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getSetDashboardLocations = (
  id: string,
  page?: number,
  limit?: number,
) => {
  const { dispatch } = store;
  if (!page) return;
  dispatch(setLocationLoading(true));
  // Replace {studioId} in the route with the value
  let apiendpoint = endPoints.riskSecurity.setDashboardLocations.replace(
    '{setId}',
    id || '',
  );

  // Add pagination params
  apiendpoint = `${apiendpoint}?page=${page}&limit=${limit}`;

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLocationLoading(false));
        dispatch(setSetDashboardLocations(data?.data));
      }
    },
    (e: any) => {
      dispatch(setLocationLoading(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

// export const getSetDashboardGraphLocations = (
//   id: string,
//   riskLevel?: string,
//   cb?: any,
// ) => {
//   const { dispatch } = store;

//   // Replace {studioId} in the route with the value
//   let apiendpoint = endPoints.riskSecurity.setDashboardLocationsCards.replace(
//     '{setId}',
//     id || '',
//   );

//   if (riskLevel) {
//     apiendpoint = apiendpoint + `?riskLevel=${riskLevel}`;
//   }

//   // Make the API call
//   getApiCall(
//     `${apiendpoint}`,
//     (s: any) => {
//       const { data } = s;
//       if (data?.data) {
//         dispatch(setSetDashboardmapLocations(data?.data));
//         if (cb) cb(data?.data);
//       }
//     },
//     (e: any) => {
//       if (e?.data && e?.data.message) {
//         notify(e?.data.message, 'error');
//       } else {
//         notify(null, 'error');
//       }
//     },
//   );
// };

export const getSetDashboardGraphLocations = (
  id: string,
  params?: {
    riskLevel?: string;
    locationId?: string;
    searchKey?: string;
  },
  cb?: any,
) => {
  const apiendpoint = endPoints.riskSecurity.setDashboardLocationsCards.replace(
    '{setId}',
    id || '',
  );

  const query = new URLSearchParams();

  if (params?.riskLevel) query.append('riskLevel', params.riskLevel);
  if (params?.locationId) query.append('locationId', params.locationId);
  if (params?.searchkey) query.append('searchkey', params.searchkey);

  // if (params?.page) query.append('page', String(params.page));
  // if (params?.limit) query.append('limit', String(params.limit));

  const url = query.toString()
    ? `${apiendpoint}?${query.toString()}`
    : apiendpoint;

  getApiCall(
    url,
    (s: any) => {
      if (cb) cb(s?.data);
    },
    (e: any) => {
      notify(e?.data?.message || null, 'error');
    },
  );
};

export const getRiskLocationBasicDetails = (id: string) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.locationDashOverview.replace(
    '{locationId}',
    id || '',
  );
  dispatch(setLoading(true));

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLoading(false));
        dispatch(setLocationDetails(data?.data));
      }
    },
    (e: any) => {
      dispatch(setLoading(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getRiskLocationThreatAlerts = (id: string) => {
  const { dispatch } = store;
  dispatch(setLoading(true));
  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.locationThreatAlerts.replace(
    '{locationId}',
    id || '',
  );

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLoading(false));
        dispatch(setLocationThreatDetails(data?.data));
      }
    },
    (e: any) => {
      dispatch(setLoading(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const acknowledgeThreatAlert = (
  id: string,
  itemId: string,
  cb?: any,
  errorCb?: any,
  acknowledge?: boolean,
) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.acknowledgeThreat
    .replace('{locationId}', id || '')
    .replace('{classificationId}', itemId);

  // Make the API call
  postApiCall(
    `${apiendpoint}`,
    { acknowledge: acknowledge },
    () => {
      notify('Acknowledged Successfully', 'success');
      cb && cb();
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
      errorCb && errorCb();
    },
  );
};
export const updateThreatAlert = (
  id: string,
  itemId: string,
  data: any,
  cb?: any,
  errorCb?: any,
) => {
  const { dispatch } = store;

  // Replace {studioId} in the route with the value
  const apiendpoint = endPoints.riskSecurity.updateThreatAlert
    .replace('{locationId}', id || '')
    .replace('{classificationId}', itemId);

  // Make the API call
  putApiCall(
    `${apiendpoint}`,
    data,
    () => {
      notify('Updated Successfully', 'success');
      cb && cb();
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
      errorCb && errorCb();
    },
  );
};
export const checkAlreadyCreatedThreat = (
  studioId: string | undefined | null,
  productionId: string,
  episodeId: string,
  setId: string,
  locationIds: string[],
  cb?: any,
) => {
  console.log('haan');
  const { dispatch } = store;
  dispatch(setLoading(true));
  // Replace {studioId} in the route with the value

  const buildQueryParams = (params: Record<string, any>) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value == null || value === '') return;

      if (Array.isArray(value)) {
        value.forEach(v => {
          if (v != null && v !== '') {
            searchParams.append(key, String(v));
          }
        });
      } else {
        searchParams.append(key, String(value));
      }
    });

    return searchParams.toString();
  };

  const apiendpoint =
    endPoints.riskSecurity.checkAlreadyCreated +
    (productionId || episodeId || setId || locationIds || studioId
      ? `?${buildQueryParams({
          productionId,
          episodeId,
          setId,
          locationIds,
          studioId,
        })}`
      : '');

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (
        locationIds?.length <= 1
          ? data?.data
          : {
              isExist: data?.data?.results?.find((d: any) => d.isExist)
                ? true
                : false,
            }
      ) {
        cb?.(
          locationIds?.length <= 1
            ? data?.data
            : {
                isExist: data?.data?.results?.find((d: any) => d.isExist)
                  ? true
                  : false,
              },
        );
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};
export default riskSecuritySlice.reducer;

export const exportPdf = (id: string, locationId?: string, cb?: any) => {
  const { dispatch } = store;
  if (cb) cb(true);

  // Replace {studioId} in the route with the value
  let apiendpoint = endPoints.riskSecurity.exportPdf.replace(
    '{reportId}',
    id || '',
  );

  if (locationId) {
    apiendpoint += `?locationId=${locationId}`;
  }
  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        if (cb) cb(false);
        try {
          logEvent(analytics, ANALYTICS_EVENTS.RISK_PDF_EXPORTED, {
            threat_id: id,
          });
        } catch (_) {}
        downloadPdf(data?.data?.pdfLink, data?.data?.fileName);
        // notify(data?.data?.message, 'success');
      }
    },
    (e: any) => {
      if (cb) cb(false);
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};
export const getActiveLocation = (id: string, type = 'dashboard') => {
  const { dispatch } = store;
  // dispatch(setLoading(true));
  // Replace entityId and type (dashboard, location, studio, etc.)
  const apiendpoint = endPoints.riskSecurity.locationWithActive
    .replace('{entityId}', id || '')
    .replace('{dashboardType}', type);

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLoading(false));
        dispatch(setActiveCriticalLocations(data?.data));
      }
    },
    (e: any) => {
      notify(e?.data?.message || null, 'error');
      dispatch(setLoading(false));
    },
  );
};

export const getRiskLoggedinUserDetail = (id: string, type = 'studio') => {
  const { dispatch } = store;
  // dispatch(setLoading(true));
  // Replace entityId and type (dashboard, location, studio, etc.)
  const apiendpoint = `${endPoints.riskSecurity.userAccess}?entityId=${id}&entityType=${type}`;

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLoading(false));
        dispatch(setRiskLoggedInUserDetail(data?.data));
      }
    },
    (e: any) => {
      notify(e?.data?.message || null, 'error');
      dispatch(setLoading(false));
    },
  );
};

export const getThreatDetail = (
  entityType: string,
  entityId: string,
  classificationId: string,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true));
  // Replace entityId and type (dashboard, location, studio, etc.)
  const apiendpoint = endPoints.riskSecurity.threatDetail
    .replace('{dashboardType}', entityType)
    .replace('{entityId}', entityId)
    .replace('{classificationId}', classificationId);

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setLoading(false));
        dispatch(setSingleThreatDetail(data?.data));
      }
    },
    (e: any) => {
      notify(e?.data?.message || null, 'error');
      dispatch(setLoading(false));
    },
  );
};
